<div class="addNewGrowerModal">
  <div class="grower-add-form">
    <h4>
      Request to add a new grower to our system:
    </h4>
    <div class="inline-error" *ngIf="error">
      <div class="row">
        <div class="col-md-12">
          <ol class="error-list">
            <li class="justify-content-center align-self-center">
              <pre>{{ErrorMessage}}</pre>
            </li>
            <!--<li *ngIf="gwrCtrl.errors?.pattern">
              Grower Code is Alphanumeric.
            </li>-->
          </ol>
        </div>
      </div>
    </div>

    <form #addGrowerForm="ngForm" autocomplete="off">
      <div class="form-sec">
        <div class="row">
          <div class="col-md-12">
            <h5>
              GROWER INFORMATION
            </h5>
          </div>
          <div class="col-md-12">
            <mat-form-field class="wide100">
              <input matInput type=text name="businessName"
                     placeholder="Business Name:"
                     [(ngModel)]="newGrower.BusinessName" #bnCtrl="ngModel"
                     autocomplete="off">
            </mat-form-field>
          </div>
          <div class="col-md-6 sellerSearch">
            <mat-form-field class="wide100">
              <input matInput type=text name="firstName"
                     placeholder="First Name:"
                     [(ngModel)]="newGrower.FirstName"
                     autocomplete="off">
            </mat-form-field>
          </div>
          <div class="col-md-6">
            <mat-form-field class="wide100">
              <input matInput type=text name="lastName"
                     placeholder="Last Name:"
                     [(ngModel)]="newGrower.LastName"
                     autocomplete="off">
            </mat-form-field>
          </div>
          <div class="col-md-12">
            <mat-form-field class="wide50">
              <input matInput type=text name="gln"
                     placeholder="GLN:"
                     [(ngModel)]="newGrower.GLN"
                     maxlength="13"
                     autocomplete="off"
                     (keypress)="keyPressNumbers($event)">
            </mat-form-field>
          </div>
          <div class="col-md-6 material-select">
            <ng-select id="ddlaccount"
                       name="account"
                       [items]="accountSearchData"
                       placeholder="Account"
                       [(ngModel)]="newGrower.ABNumber"
                       [virtualScroll]="true"
                       bindLabel="accountNameCityState"
                       bindValue="accountNumber"
                       [loading]="accountLoading"
                       class="custom-select-grower"
                       [closeOnSelect]="true"
                       [disabled]=" true">

              <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                <div class="dropdown-template">
                  <div class="row">
                    <div class="col-md-8">
                      <h4 class="name" [ngOptionHighlight]="search">
                        {{item.accountName}}
                      </h4>
                      <p class="address" [ngOptionHighlight]="search">
                        {{item.address1}},  {{item.city}}, {{item.state}} - {{item.zipCode}}
                      </p>
                      <p class="phoneNo" [ngOptionHighlight]="search">
                        {{item.primaryPhoneNumber}}
                      </p>
                      <p class="grower-nos">
                        <span class="grower-gln" [ngOptionHighlight]="search">
                          Account #: {{item.accountNumber}}
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              </ng-template>
              <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                <div class="ng-option disabled">
                  No data found for "{{searchTerm}}"
                </div>
              </ng-template>
              <ng-template ng-footer-tmp let-search="searchTerm">
                <div class="custom-drop-footer">
                  <div class="row">
                    <div class="col-md-8">Select an option above to filter</div>
                    <div class="col-md-4">{{this.accountDataCount}} Results</div>
                  </div>
                </div>
              </ng-template>
            </ng-select>
          </div>
          <!--<div class="col-md-6 margin-t12">
            <mat-form-field class="wide100" [class.invalid-field]="newGrowerError.GrowerCode">
              <input matInput type=text name="growerCode"
                     placeholder="Grower Code:"
                     [(ngModel)]="newGrower.GrowerCode"
                     (focusout)="validate('growerCode',newGrower.GrowerCode)"
                     #gwrCtrl="ngModel"
                     pattern="^[a-zA-Z0-9]+$"
                     autocomplete="off">
            </mat-form-field>
          </div>-->
        </div>
        <div class="row margin-t30">
          <div class="col-md-12">
            <h5>
              BUSINESS ADDRESS
            </h5>
          </div>
          <div class="col-md-12">

            <mat-form-field class="wide100">
              <input matInput type=text name="address1"
                     placeholder="Address:"
                     [(ngModel)]="addresses.Address1"
                     autocomplete="off">
            </mat-form-field>
          </div>
          <!--<div class="col-md-6">
            <mat-form-field class="wide100">
              <input matInput type=text name="address2"
                     placeholder="Suite"
                     [(ngModel)]="addresses.Address2"
                     autocomplete="off">
            </mat-form-field>
          </div>-->
        </div>

        <div class="row sellerSearch">
          <div class="col-md-4 margin-t12">
            <mat-form-field class="wide100">
              <input matInput type=text name="city"
                     placeholder="City"
                     [(ngModel)]="addresses.City"
                     autocomplete="off">
            </mat-form-field>
          </div>
          <div class="col-md-4 material-select">
            <ng-select id="ddlState"
                       name="state"
                       placeholder="State"
                       class="custom-select-grower"
                       [items]="stateDS"
                       [(ngModel)]="addresses.State"
                       [multiple]="false"
                       [hideSelected]="true"
                       [virtualScroll]="true"
                       bindLabel="value"
                       bindValue="value"
                       [searchFn]="stateSearchFn"
                       [closeOnSelect]="true">
              <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                <div class="dropdown-template">
                  <div class="row">
                    <div class="col-md-8">
                      <p class="name">
                        {{item.value}}
                      </p>
                    </div>
                  </div>
                </div>
              </ng-template>
              <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                <div class="ng-option disabled">
                  No data found for ""
                </div>
              </ng-template>
            </ng-select>
          </div>
          <div class="col-md-4 margin-t12">
            <mat-form-field class="wide100">
              <input matInput type=text name="zip"
                     placeholder="Zipcode"
                     [(ngModel)]="addresses.Zip"
                     autocomplete="off">
            </mat-form-field>
          </div>
        </div>
      </div>
      <div class="row ButtonSec">
        <div class="col-md-12">
          <button mat-raised-button class="btns" color="primary" type="submit" (click)='requestGrower(addGrowerForm)'>Request New Grower</button>
        </div>
      </div>
    </form>
  </div>
</div>
